import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import * as constants from './constant'

@Injectable()
export class TokenServiceService {

  private stateCode = new BehaviorSubject<any>({});
  selectedstateCode = this.stateCode.asObservable();

  constructor() { }

  setState(state: any) {
    if (state == constants.STATES.MP.CODE) {
      this.stateCode.next(constants.STATES.MP.KEY);
    } else if (state == constants.STATES.KA.CODE) {
      this.stateCode.next(constants.STATES.KA.KEY);
    } else if(state == constants.STATES.AD.CODE){
      this.stateCode.next(constants.STATES.AD.KEY);
    }else if(state == constants.STATES.RJ.CODE){
      this.stateCode.next(constants.STATES.RJ.KEY);
    }else if(state == constants.STATES.GJ.CODE){
      this.stateCode.next(constants.STATES.GJ.KEY);
    }else if(state == constants.STATES.MH.CODE){
      this.stateCode.next(constants.STATES.MH.KEY);
    }
    else {
      this.stateCode.next('SxEYWccmPUCnF5fjVllxaAAILN4OG6kr');
    }
  }

}
